import { render } from "./SiteHeaderAndSidebar.vue?vue&type=template&id=006bbecc&scoped=true"
import script from "./SiteHeaderAndSidebar.vue?vue&type=script&lang=js"
export * from "./SiteHeaderAndSidebar.vue?vue&type=script&lang=js"

import "./SiteHeaderAndSidebar.vue?vue&type=style&index=0&id=006bbecc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006bbecc"]])

export default __exports__